module.exports = __webpack_public_path__ + "03_long_gray.500db44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_long_gray.png
// module id = M3br
// module chunks = 0